import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/@babel/runtime/regenerator/index.js";
import { faArrowUpArrowDown, faBell, faChevronRight, faFile, faList, faMemoPad, faShareNodes, faUserGroup, faXmark, faHardDrive, faKey } from "@fortawesome/pro-regular-svg-icons";
import { getCurrentRegion, getIsLoggedIn, getIsOnpremise, getIsPatientDeletionEnabled, hasSiteKeyword, isWebView } from "../../utils";
import { trackEvent } from "../../utils/mixpanel";
import AwesomeIcon from "../AwesomeIcon";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import Store from "../../utils/Store";
import { useContext, useState } from "react";
import { GatewayContext } from "../GatewayIndicator/GatewayContext";
import { useRouter } from "next/router";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import UserBio from "./UserBio";
import constants from "../../utils/constants";
import Toggle from "../common/Toggle";
import { get } from "lodash";
import { useStoreState } from "pullstate";
import useSaveNotificationSettings from "../NotificationSettings/hooks/useSaveNotificationSettings";
import useAuthService from "../../hooks/useAuthService";
import Toast from "../Toast";
import { faDownload, faInfoCircle, faLocationDot, faMobileNotch, faSunBright, faUsersMedical, faWifi, faMobileSignalOut } from "@fortawesome/pro-regular-svg-icons";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import TermsAndConditionsModal from "../TermsAndConditionsModal";
import { subscribeUserNotification } from "../../utils/pushNotification";
import Loader from "../Loader";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { LicenseContext } from "../LicenseManager/LicenseContext";
import getEnv from "../../utils/getEnv";
var NEXT_PUBLIC_ENABLE_SCAN_TO_CONNECT = getEnv("NEXT_PUBLIC_ENABLE_SCAN_TO_CONNECT") === "true";
var SettingsMenu = function SettingsMenu(props) {
  var _window, _window2;
  var onLogout = props.onLogout,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
    onChange = props.onChange,
    selected = props.selected;
  var _useState = useState(false),
    showTermsAndConditionsModal = _useState[0],
    setShowTermsAndConditionsModal = _useState[1];
  var _useState2 = useState(false),
    isSubscribeLoading = _useState2[0],
    setSubscribeLoading = _useState2[1];
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isOnpremise = getIsOnpremise();
  var isPatientDeletionEnabled = getIsPatientDeletionEnabled();
  var _useContext = useContext(GatewayContext),
    offlineGatewayCount = _useContext.offlineGatewayCount,
    totalGateway = _useContext.totalGateway;
  var router = useRouter();
  var _useContext2 = useContext(LicenseContext),
    alertDetails = _useContext2.alertDetails;
  var _useStoreState = useStoreState(Store, function (store) {
      return {
        userInfo: store.userInfo,
        isNotificationSubscribing: store.isNotificationSubscribing,
        isDarkMode: store.isDarkMode,
        isExportReady: store.isExportReady,
        downloadProgress: store.downloadProgress,
        isStartingDownload: store.isStartingDownload,
        exportGenFailed: store.exportGenFailed,
        isRNTestBuild: store.isRNTestBuild,
        RNSelectedEnv: store.RNSelectedEnv,
        RNfcmToken: store.RNfcmToken,
        fcmToken: store.fcmToken,
        isDiskSpaceWarning: store.isDiskSpaceWarning
      };
    }),
    userInfo = _useStoreState.userInfo,
    isNotificationSubscribing = _useStoreState.isNotificationSubscribing,
    isDarkMode = _useStoreState.isDarkMode,
    isExportReady = _useStoreState.isExportReady,
    downloadProgress = _useStoreState.downloadProgress,
    isStartingDownload = _useStoreState.isStartingDownload,
    exportGenFailed = _useStoreState.exportGenFailed,
    isRNTestBuild = _useStoreState.isRNTestBuild,
    RNSelectedEnv = _useStoreState.RNSelectedEnv,
    RNfcmToken = _useStoreState.RNfcmToken,
    fcmToken = _useStoreState.fcmToken,
    isDiskSpaceWarning = _useStoreState.isDiskSpaceWarning;
  var saveNotificationSettings = useSaveNotificationSettings();
  var _useAuthService = useAuthService(false),
    refetchProfile = _useAuthService.refetch,
    isProfileLoading = _useAuthService.isFetching;
  var isLoggedIn = getIsLoggedIn();
  var isMobileApp = (_window = window) === null || _window === void 0 ? void 0 : _window.ReactNativeWebView;
  var isNotificationOn = !isLoggedIn || !get(userInfo, ["settings", "notification_snoozed"], false);
  var token = RNfcmToken || fcmToken;
  var hasPermission = isMobileApp && !!RNfcmToken || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Notification) === null || _window2 === void 0 ? void 0 : _window2.permission) === "granted";
  var isSubscribed = isNotificationSubscribing || !isLoggedIn && hasPermission || !token && hasPermission || get(userInfo, ["subscription_tokens"], []).some(function (tokenObj) {
    return get(tokenObj, ["token"], "") === token;
  });
  var isLicenseEnabled = get(userInfo, ["settings", "is_licensing_enabled"], false);
  var settings = [{
    pageName: constants.SETTINGS.THEME,
    section: "user_settings",
    icon: faSunBright,
    viewOnly: true,
    className: isMobile ? "hidden" : "",
    control: function control() {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("flex items-center p-4 gap-4 cursor-pointer"),
        onClick: onToggleThemeClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-sm uppercase"
      }, isDarkMode ? t("settings.dark") : t("settings.light")), /*#__PURE__*/React.createElement(Toggle, {
        value: !isDarkMode || false,
        onChange: onToggleThemeClick
      }));
    }
  }, {
    pageName: constants.SETTINGS.NOTIFICATIONS,
    section: "user_settings",
    icon: faBell,
    className: classNames({
      hidden: isOnpremise
    }),
    control: function control() {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames("flex sm:hidden items-center border-l border-gray-800 p-4 gap-4")
      }, /*#__PURE__*/React.createElement("div", null, t("settings.on")), /*#__PURE__*/React.createElement(Toggle, {
        value: isNotificationOn,
        onChange: onToggleNotification,
        disabled: !isSubscribed || !hasPermission || saveNotificationSettings.isLoading || isProfileLoading || isNotificationSubscribing
      }));
    }
  }, {
    pageName: constants.SETTINGS.WORKLIST_TAGS,
    section: "user_settings",
    icon: faList
  }, {
    pageName: constants.SETTINGS.FORM_TEMPLATES,
    section: "user_settings",
    icon: faMemoPad
  }, {
    pageName: constants.SETTINGS.AUTOMATED_SHARING,
    section: "user_settings",
    icon: faShareNodes,
    className: classNames({
      hidden: isOnpremise
    })
  }, {
    pageName: constants.SETTINGS.USER_GROUPS,
    section: "user_settings",
    icon: faUserGroup,
    className: classNames({
      hidden: isOnpremise
    })
  }, {
    pageName: hasSiteKeyword() ? constants.SETTINGS.SITE_MANAGEMENT : constants.SETTINGS.WORKSPACE_MANAGEMENT,
    section: "user_settings",
    icon: faUsersMedical,
    className: classNames({
      hidden: isMobile
    })
  }, {
    pageName: constants.SETTINGS.REPORT_TEMPLATE,
    section: "user_settings",
    icon: faFile,
    className: classNames({
      hidden: isMobile
    })
  }, {
    pageName: constants.SETTINGS.DISK_MANAGEMENT,
    section: "user_settings",
    icon: faHardDrive,
    className: classNames({
      hidden: isMobile || !(isOnpremise && isPatientDeletionEnabled)
    }),
    control: function control() {
      if (isDiskSpaceWarning) {
        return /*#__PURE__*/React.createElement("div", {
          className: classNames("flex items-center p-4 gap-4")
        }, /*#__PURE__*/React.createElement(AwesomeIcon, {
          name: faTriangleExclamation,
          className: "text-yellow-500"
        }));
      }
      return null;
    }
  }, {
    pageName: constants.SETTINGS.LICENSE_MANAGER,
    section: "user_settings",
    icon: faKey,
    control: function control() {
      if (alertDetails !== null && alertDetails !== void 0 && alertDetails.isAlert) {
        return /*#__PURE__*/React.createElement(AwesomeIcon, {
          name: faTriangleExclamation,
          className: "text-yellow-500 mr-5"
        });
      }
      return null;
    },
    className: classNames({
      hidden: isMobile || !isOnpremise || !isLicenseEnabled
    })
  }, {
    pageName: constants.SETTINGS.EXPORT_DATA,
    section: "more",
    icon: faDownload,
    control: function control() {
      var status = /*#__PURE__*/React.createElement("div", {
        className: "text-sm uppercase"
      }, t("settings.download"));
      if (isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady) {
        status = /*#__PURE__*/React.createElement("div", {
          className: "w-6 h-6"
        }, /*#__PURE__*/React.createElement(CircularProgressbar, {
          value: downloadProgress,
          styles: buildStyles({
            rotation: 0.25,
            strokeLinecap: "butt",
            textSize: "24px",
            pathTransitionDuration: 0.5,
            pathColor: "rgba(0, 130, 128)",
            textColor: "#f88",
            trailColor: isDarkMode ? "white" : "#b6aeae",
            backgroundColor: "white"
          })
        }));
      } else if (exportGenFailed) {
        status = /*#__PURE__*/React.createElement("div", {
          className: "flex text-md text-red-600 dark:text-red-400 font-normal"
        }, t("settings.export_failed"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "cursor-pointer mr-3"
      }, status);
    },
    onClick: function onClick(pageName) {
      Store.update(function (s) {
        s.showExportUpdate = isExportReady;
        s.isExportDataOpen = !isExportReady && (downloadProgress === 0 || downloadProgress === 100) && !isStartingDownload;
        s.isSettingsOpen = false;
      });
      trackEvent(MIXPANEL_EVENTS.SELECT_SETTING, {
        pageName: pageName
      });
    },
    className: classNames({
      "opacity-50": isStartingDownload || downloadProgress > 0 && downloadProgress < 100 && !isExportReady,
      hidden: isMobile
    })
  }, {
    pageName: constants.SETTINGS.GATEWAY,
    section: "more",
    icon: faArrowUpArrowDown,
    count: offlineGatewayCount,
    className: classNames({
      hidden: !totalGateway
    })
  },
  // {
  //   pageName: constants.SETTINGS.MODALITY_CONNECT,
  //   section: "more",
  //   icon: faNetworkWired,
  //   className: classNames({ hidden: isMobile || isOnpremise }),
  // },
  {
    pageName: constants.SETTINGS.SCAN_TO_CONNECT,
    section: "more",
    icon: faMobileSignalOut,
    className: classNames({
      hidden: !isOnpremise || !NEXT_PUBLIC_ENABLE_SCAN_TO_CONNECT
    })
  }, {
    pageName: constants.SETTINGS.REMOTE_ACCESS,
    section: "more",
    icon: faWifi,
    className: classNames({
      hidden: !isOnpremise
    })
  }, {
    pageName: constants.SETTINGS.TERMS_OF_USE,
    section: "more",
    icon: faInfoCircle,
    className: classNames({
      hidden: !isMobile
    }),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
      trackEvent(MIXPANEL_EVENTS.OPEN_TERMS_OF_USE);
    }
  }, {
    pageName: constants.SETTINGS.REGION,
    customLabel: t(getCurrentRegion()),
    section: "more",
    icon: faLocationDot,
    viewOnly: true,
    className: classNames("cursor-default", {
      hidden: isOnpremise || !isMobile
    })
  }];
  var onToggleThemeClick = function onToggleThemeClick() {
    if (window) {
      localStorage.setItem(constants.PERSISTED.isDarkMode, String(!isDarkMode));
      Store.update(function (s) {
        s.isDarkMode = !isDarkMode;
      });
      trackEvent(MIXPANEL_EVENTS.THEME_CHANGED, {
        isDarkMode: !isDarkMode
      });
    }
  };
  var onToggleNotification = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            payload = {
              notification_snoozed: !value
            };
            _context.next = 4;
            return saveNotificationSettings.mutateAsync(payload);
          case 4:
            _context.next = 6;
            return refetchProfile();
          case 6:
            trackEvent(MIXPANEL_EVENTS.UPDATE_NOTIFICATION_SETTINGS, {
              notification_snoozed: payload.notification_snoozed
            });
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            Toast.error("Something went wrong. Please retry");
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return function onToggleNotification(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var onChangeSetting = function onChangeSetting(pageName) {
    if (onChange) {
      onChange(pageName);
    } else {
      router.push("/settings/".concat(pageName), undefined, {
        shallow: true
      });
    }
    trackEvent(MIXPANEL_EVENTS.SELECT_SETTING, {
      pageName: pageName
    });
  };
  var onUpdateSubscription = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _window3, data, subscription;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(isMobileApp && !hasPermission)) {
              _context2.next = 5;
              break;
            }
            data = {
              event: constants.RN_COMM_CONST.OPEN_APP_SETTINGS,
              data: null
            };
            (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.ReactNativeWebView) === null || _window3 === void 0 || _window3.postMessage(JSON.stringify(data));
            _context2.next = 14;
            break;
          case 5:
            setSubscribeLoading(true);
            _context2.next = 8;
            return subscribeUserNotification(RNfcmToken);
          case 8:
            subscription = _context2.sent;
            if (!subscription) {
              _context2.next = 13;
              break;
            }
            _context2.next = 12;
            return refetchProfile();
          case 12:
            setSubscribeLoading(false);
          case 13:
            setSubscribeLoading(false);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function onUpdateSubscription() {
      return _ref2.apply(this, arguments);
    };
  }();
  var _section = "";
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("flex flex-col h-full bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 w-full sm:w-2/5", {
      "pt-6": isWebView()
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start p-4 sm:pl-6 text-lg border-b border-gray-300 dark:border-gray-700"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "flex sm:hidden p-4"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "h-6 w-6 "
  })), /*#__PURE__*/React.createElement("div", null, t("settings_key"))), !isOnpremise && isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, (!hasPermission || !isSubscribed) && /*#__PURE__*/React.createElement("div", {
    className: "inline bg-yellow-900 text-md p-4 py-5"
  }, isSubscribeLoading ? /*#__PURE__*/React.createElement(Loader, {
    size: "medium",
    label: "Please wait",
    className: "mr-3",
    containerClassName: "!py-0 flex !flex-row"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "pr-2"
  }, t("notification_modal.no_notifications_setting")), /*#__PURE__*/React.createElement("span", {
    className: "text-yellow-400 font-bold cursor-pointer",
    onClick: onUpdateSubscription
  }, t("notification_modal.update_settings"))))), /*#__PURE__*/React.createElement(UserBio, {
    onLogout: onLogout
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-auto scrollbar-light dark:scrollbar"
  }, settings.map(function (_setting, idx) {
    var _setting$className = _setting.className,
      className = _setting$className === void 0 ? "" : _setting$className,
      section = _setting.section,
      pageName = _setting.pageName,
      count = _setting.count,
      icon = _setting.icon,
      viewOnly = _setting.viewOnly,
      control = _setting.control,
      _onClick = _setting.onClick,
      customLabel = _setting.customLabel;
    var header = null;
    if (section !== _section) {
      _section = section;
      header = /*#__PURE__*/React.createElement("div", {
        key: section,
        className: "flex items-center font-semibold uppercase text-gray-800 dark:text-gray-300 py-3 px-5 mt-3"
      }, t("settings.".concat(section)), /*#__PURE__*/React.createElement("hr", {
        className: "flex grow border-gray-300 dark:border-gray-700 ml-3"
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, header, /*#__PURE__*/React.createElement("div", {
      className: classNames("flex items-center justify-between ", _defineProperty({
        "hover:bg-gray-200 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200 cursor-pointer": !viewOnly,
        "bg-gray-200 dark:bg-gray-800 text-gray-800 dark:text-gray-200": pageName === selected
      }, className, !!className)),
      key: pageName,
      onClick: function onClick() {
        if (!viewOnly) {
          if (_onClick) {
            _onClick(pageName);
          } else {
            onChangeSetting(pageName);
          }
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("flex py-4 items-center justify-between px-5 w-full", {})
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, count > 0 && /*#__PURE__*/React.createElement("div", {
      className: "absolute border-gray-800 flex justify-center items-center text-sm rounded-full bg-red-600 text-gray-100 right-4 font-medium -top-1 w-5 h-5"
    }, count), icon && /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: icon,
      size: "lg",
      className: "mr-5 w-6"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start whitespace-nowrap"
    }, customLabel || t("settings.".concat(pageName)))), /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faChevronRight,
      size: "lg",
      className: classNames("sm:hidden justify-self-end", {
        hidden: viewOnly
      })
    })), control && control()));
  }), !!isRNTestBuild && /*#__PURE__*/React.createElement("div", {
    className: "",
    onClick: function onClick() {
      Store.update(function (s) {
        s.isRNEnvSelectorOpen = true;
      });
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex p-4 items-center justify-start"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMobileNotch,
    className: "h-6 w-6 mr-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-start justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-start"
  }, "Debug Environment"), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start text-sm"
  }, RNSelectedEnv))))), showTermsAndConditionsModal && /*#__PURE__*/React.createElement(TermsAndConditionsModal, {
    onClose: function onClose() {
      setShowTermsAndConditionsModal(false);
    }
    // closeOnClickAway
    ,
    mode: "readonly"
  }));
};
export default SettingsMenu;